import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { supportApi as r } from "@maat/api-main";
//#region src/support/admin/useAdminUpdateTicketMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, payload: t }) => r.adminUpdateTicket(e, t),
		onSuccess: (t, { id: n }) => {
			i.invalidateQueries({ queryKey: e.ticket(n) }), i.invalidateQueries({ queryKey: e.tickets() }), i.invalidateQueries({ queryKey: e.ticketStats() });
		}
	});
};
//#endregion
export { i as useAdminUpdateTicketMutation };
